import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncViewAllAnnouncement({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/viewAllAnnouncement"));
  console.log("Loading", AsyncViewAllAnnouncement.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncViewAllAnnouncement;
